import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_PROFILE_URL, BASE_URL, BASE_USER_URL } from '../apiConfig';

const authenticateUser = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_USER_URL}/login`,
    payload,
  );
  return response.data;
};

const verifyOTP = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_USER_URL}/verify-otp`,
    payload,
  );
  return response.data;
};

const resendOTP = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_USER_URL}/resend-otp`,
    payload,
  );
  return response.data;
};

const createUser = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PROFILE_URL}/save-user`,
    payload,
  );
  return response.data;
};

const changeEmployee = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_PROFILE_URL}/change-employee-no`,
    payload,
  );
  return response;
};

export { authenticateUser, verifyOTP, resendOTP, createUser, changeEmployee };
